import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { notify } from 'libs/common';
import { FilledButton } from 'libs/ui';
import { Window } from 'components/shared/window/window';
import { Content, Item, Title, Value, ItemButtons } from './settingslimits.styled';

export const SettingsLimits = (props) => {
  const { t } = useTranslation();
  const { data } = props;
  const zones = useSelector((state) => state.boards.boards);
  const [zonescnt, setZonescnt] = useState(zones);

  const changeZone = (event) => {
    let val = event.target.value;
    if (!val) {
      val = 0;
    }

    if (val > zones[event.target.name].maximum) {
      val = zones[event.target.name].maximum;
    }

    const name = event.target.name;

    const out = { ...zonescnt };
    out[name].regular = val;
    setZonescnt(out);
  };

  const save = (zoneId) => {
    const val = parseInt(zonescnt[zoneId].regular);
    const zoneMax = zones[zoneId].maximum;

    if (val > zoneMax) {
      notify(t('messages.Ошибка'), t('messages.Количество мест не может превышать ') + zoneMax);
      return;
    }

    const out = { zone_id: zoneId, count: val };

    socket.call('set_zone_regular_places', out);
    notify(t('widgets.Постоянные клиенты'), t('widgets.Изменения для зоны ') + zoneId + t('widgets. сохранены'), 'success');
  };

  const getItemsEl = () => {
    return Object.keys(zones).map((id) => {
      const zone = zones[id];
      const val = zonescnt[id].regular || '';
      if (val === undefined) {
        return (
          <Item>
            <Title>
              {zone.name}: {t(' не поддерживается')}
            </Title>
          </Item>
        );
      }
      return (
        <Item key={id}>
          <Title>{zone.name}</Title>
          <Value>
            <input type="number" name={id} value={val} onChange={changeZone} max={zone.maximum} min={0} />
          </Value>
          <ItemButtons>
            <FilledButton color="success" onClick={() => save(id)}>
              {t('buttons.Сохранить')}
            </FilledButton>
          </ItemButtons>
        </Item>
      );
    });
  };

  if (!zones || !Object.keys(zones).length) {
    return null;
  }

  const itemsEl = getItemsEl();

  const x = window.innerWidth / 2 - 162;

  return (
    <Window width="390px" {...data} defaultPosition={{ x, y: 40 }}>
      <Content>{itemsEl}</Content>
    </Window>
  );
};
